import Resource from '@/services/resources/common';

// question type
export default class TypeResource extends Resource {
  constructor(entrypoint = '/types', alias = 'Type') {
    super(entrypoint, alias);
  }
}
